<ng-container *transloco="let t">
  <section class="content-products">
    <div class="ui-title">
      <a class="ui-item-link" [routerLink]="['../']">
        <pxw-icon icon="back"></pxw-icon>
      </a>
      {{ t('searchResults.title') }}
      @if (productTagsWithQuantities().length > 0) {
        <pxw-button
          size="sm"
          [rounded]="true"
          color="theme2-contrast"
          (click)="onFilterProducts()"
          style="margin-left: 0.5em"
        >
          <pxw-icon icon="filter" />
          {{ t('productFiltersDialog.title') }}
        </pxw-button>
      }
    </div>
    <pxw-item-list
      groupingStrategy="category"
      [itemListGroups]="searchResults() | pxwItemListGroupProductsByCategory: categories()"
      [emptyListText]="t('searchResults.emptyList')"
      [itemHeight]="90"
      [rememberScrollSettings]="{ key: 'search-results', context: searchText() }"
      [autoHideSlider]="true"
    >
      <ng-template #groupHeadingTemplate let-groupItem="groupItem" let-category="group">
        <h2 class="group-heading">
          <span class="title">
            {{ category.name }}
            <span class="count">({{ groupItem.indexedItems.length }})</span>
          </span>
        </h2>
        @if ((category | pxwIsCategoryAvailable$ | async) === false) {
          <div class="not-available-wrapper">
            <pxw-alert class="not-available-alert" type="warning" size="sm">
              <pxw-icon icon="clock" />
              <div class="not-available-content">
                {{ t('categoryAvailability.productsNotAvailable') }}
                <pxw-button
                  color="yellow"
                  size="sm"
                  [rounded]="true"
                  (click)="categoryAvailabilityDialog.open(category)"
                >
                  {{ t('categoryAvailability.checkSchedule') }}
                </pxw-button>
              </div>
            </pxw-alert>
            <pxw-category-availability-dialog #categoryAvailabilityDialog />
          </div>
        }
      </ng-template>
      <ng-template #listItemTemplate let-category="group" let-product="item" let-listIndex="index">
        <app-product-list-item
          class="product-list-item"
          [id]="product.id"
          [name]="product.name"
          [image]="product.images?.[0]"
          [price]="product.price"
          [priceDiscount]="product.priceDiscount"
          [sku]="product.sku"
          [displaySku]="displaySku()"
          [isAvailable]="category | pxwIsCategoryAvailable$ | async"
          [withoutStock]="(product | pxwStockIsOutOfStock | async) ?? false"
            [purchaseRestrictions]="product"
            [purchaseOptions]="purchaseOptions()"
          [tag]="product.primaryTag"
          [presentationItems]="product.presentations?.items"
          [currencySymbol]="currencySymbol()"
          [detailRoute]="['/categoria', product.categoryId, 'producto', product.id]"
          [detailRouteQueryParams]="{ q: searchText(), qt: searchTags() }"
          [listIndex]="listIndex"
          [promotions]="getPromotionsForProduct(product.id)"
        ></app-product-list-item>
      </ng-template>
    </pxw-item-list>
  </section>

  @if (productTagsWithQuantities().length > 0) {
    <app-product-filters-dialog
      [tagsWithQuantities]="productTagsWithQuantities()"
      [selectedTagIds]="selectedTagIds()"
      (selectedTagIdsChange)="onSelectedTags($event)"
    />
  }
</ng-container>
